<template>
  <div class="home">
    <div class="left">
      <div class="gr">
        <ul class="game_type" >
            <li @click="sideMenusIndex = -1" :class="{ on: sideMenusIndex == -1 }"><img
                src="~@/img/home.png" /><span>大厅</span>
            </li>
            <li v-for="(o, index) in sideMenus" :key="o.gametype" @click="sideMenusIndex = index;currentIndexGameType=-1;qeuryAllGameListByGameTypeAsync(o.gametype);currentPlat=''"
              :class="{ on: index == sideMenusIndex }"><img :src="o.gamePicUrl + o.gamePicUrl_Path + o.picName" /><span>{{
                o.name }}</span></li>
        </ul>
      </div>
      <div class="banner">
        <div class="m-banner">
            <van-swipe ref="bannerSwipe" class="my-swipe" :autoplay="3000"  indicator-color="white" :show-indicators="false"  @change="onSwipeChange" >
              <van-swipe-item v-for="o in banners" :key="o.id"><img
                  :src="o.picUrl + '/img/promopics/app' + '/' + o.picBanner"></van-swipe-item>
            </van-swipe>
            <div class="next">
              <span @click="bannerPrev"></span>
              <span @click="bannerNext"></span>
            </div>
        </div>
        <div class="p-banner">
          <ul>
            <li :style="'background-image: url('+o.bgUrl+')'"  v-for="o,index in fixPosPromoEntiy" :key="index">
              <div>
                <p>{{o.name}}<span class="t" v-show="o.betTimes">{{o.betTimes}}x</span></p>
                <p class="s">{{o.subName}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="games" v-show="sideMenusIndex!=-1" v-if="hotSlotGameList1[3]">
        <p><img :src="hotSlotGameList1[3].icon" />供应商</p>
        <dl>
          <dd @click="currentPlat=''" :class="{on:currentPlat===''}">所有</dd>
          <dd v-for="o,index in plats" :key="index" v-show="gameTypeAllGameList[0]&&gameTypeAllGameList[0].gameType==o.gameType" @click="currentPlat=o.game" :class="{on:currentPlat==o.game}">{{o.game}}</dd>
        </dl>
        <ul class="g">
          <li v-for="o,index in gameTypeAllGameList" :key="index" v-show="currentPlat===''||currentPlat==o.plat" @click="gameLoginAsync(o.id,o.plat)">
            <img :src="o.h5img" />
          </li>
        </ul>
      </div>
      <div class="games" v-if="hotSlotGameList1[3]" v-show="sideMenusIndex==-1 && !$parent.userData.account">
        <p><img :src="hotSlotGameList1[3].icon" />{{hotSlotGameList1[3].categoryName}}</p>
        <ul class="h" ref="listWrap1">
          <li v-for="o,index in hotSlotGameList1[3].spreads" :key="index">
            <img :src="o.icon_url" />
            <span>{{o.title}}</span>
          </li>
        </ul>
      </div>
      <div class="games" v-if="hotSlotGameList1[0]" v-show="sideMenusIndex==-1">
        <p><img :src="hotSlotGameList1[0].icon" />{{hotSlotGameList1[0].categoryName}}</p>
        <ul class="g h" ref="listWrap2">
          <li v-for="o,index in hotSlotGameList1[0].games" :key="index" @click="gameLoginAsync(o.id,o.plat)">
            <img :src="o.logoUrl" />
          </li>
        </ul>
      </div>
      <div class="games" v-if="hotSlotGameList1[2]" v-show="sideMenusIndex==-1">
        <p><img :src="hotSlotGameList1[2].icon" />{{hotSlotGameList1[2].categoryName}}</p>
        <ul class="m h" ref="listWrap3">
          <li v-for="o,index in hotSlotGameList1[2].ranks" :key="index">
            <img :src="o.icon_url" />
          </li>
        </ul>
      </div>
      <div class="games" v-if="hotSlotGameList1[3]" v-show="sideMenusIndex==-1 && $parent.userData.account">
        <p><img :src="hotSlotGameList1[3].icon" />{{hotSlotGameList1[3].categoryName}}</p>
        <ul class="h" ref="listWrap1">
          <li v-for="o,index in hotSlotGameList1[3].spreads" :key="index">
            <img :src="o.icon_url" />
            <span>{{o.title}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <ul class="msg-tabs">
        <li :class="{ on: currentIndexNotice === 0 }" @click="switchNoticeTab(0)">
          <img class="tab-icon" src="@/img/sts5.png" alt="" />
          <span>公告</span>
        </li>
        <li class="tab-site" :class="{ on: currentIndexNotice === 1, 'has-unread': currentIndexNotice !== 1 && messageCount > 0 }" @click="switchNoticeTab(1)">
          <img class="tab-icon" src="@/img/chat1.png" alt="" />
          <span class="tab-label">站内信</span>
          <span class="tab-tag" v-if="isLoggedIn" :class="{ unread: messageCount > 0 }">{{ messageTagText }}</span>
        </li>
      </ul>
      <div class="msg-list">
        <template v-if="currentIndexNotice === 0">
          <div class="msg-item notice" v-for="(o, index) in noticeMessage.list" :key="'n' + index">
            <p class="title" v-if="o.title">{{ o.title }}</p>
            <div class="content">{{ o.body }}</div>
            <span class="time">{{ o.createtime }}</span>
          </div>
          <div class="msg-empty" v-show="noticeMessage.list.length === 0">
            <img src="@/img/nodata.png" />
            <span>暂无记录</span>
          </div>
        </template>
        <template v-if="currentIndexNotice === 1">
          <div class="msg-item" v-for="(o, index) in siteMessage.list" :key="'s' + index">
            <p class="title">{{ o.title }}</p>
            <div class="content">{{ o.content }}</div>
            <span class="time">{{ o.createtime }}</span>
          </div>
          <div class="msg-empty" v-show="siteMessage.list.length === 0">
            <img src="@/img/nodata.png" />
            <span>暂无记录</span>
          </div>
        </template>
      </div>
      <div class="msg-foot" @click="openNoticeAll">
        <span>{{ currentIndexNotice === 0 ? '公告' : '站内信' }}</span>
        <span>· 查看全部</span>
        <span class="arrow"></span>
      </div>
      <div class="app-dl">
        <div class="qr-side">
          <div class="qr-box" id="home_qrcode"></div>
          <p>APP下载</p>
          <div class="app-btns">
            <span :class="{ on: appPlatform === 'android' }" @click="switchAppQr('android')">安卓</span>
            <span :class="{ on: appPlatform === 'ios' }" @click="switchAppQr('ios')">IOS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qeuryHotSlotGameListVVINR,loadFixPosPromoEntiy_INR,queryGamesIe,qeuryAllGameListByGameType,queryPromosIe,gameLoginById,queryNotice,querySiteChat,qeuryMessageCount,queryAppData } from '../api';
import QRCode from 'qrcodejs2';

export default {
  name: 'GodBossHome',
  data() {
    return {
      gameList: [],
      hotSlotGameList1 : [],
      hotSlotGameList2 : [],
      hotSlotGameList3 : [],
      hostObj: {},
      fixPosPromoEntiy: [],
      sideMenus: [],
      sideMenusIndex: -1,
      currentIndexGameType: -1,
      plats: [],
      gameTypeAllGameList: [],
      promo: {
        menues: [],
        promos: []
      },
      banners: [],
      swiper: null,
      current: 0,
      currentPlat: '',
      currentIndexNotice: 0,
      noticeMessage: {
        list: []
      },
      siteMessage: {
        list: []
      },
      messageCount: 0,
      appData: {},
      appPlatform: 'android',
      homeQrcode: null
    }
  },
  computed: {
    isLoggedIn() {
      return !!(this.$parent.userData && this.$parent.userData.account);
    },
    messageTagText() {
      if (this.messageCount > 0) {
        return this.messageCount > 99 ? '99+' : String(this.messageCount);
      }
      return '已读';
    }
  },
  watch: {
    '$parent.userData.account'() {
      this.initMessageData();
    }
  },
  created(){
    this.queryGamesAsync();
    this.qeuryHotSlotGameListVVINRAsync();
    this.loadFixPosPromoEntiy_INRAsync();
    this.queryPromosIeAsync();
    this.queryNoticeAsync();
    this.initMessageData();
  },
  mounted() {
    this.initAppDownload();
  },
  methods: {
    async queryGamesAsync() {
      let result = await queryGamesIe();
      if (!result.Message) {
        this.sideMenus = result.Result.sideMenus;
        this.plats = result.Result.plats;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryHotSlotGameListVVINRAsync() {
      let result = await qeuryHotSlotGameListVVINR();
      if (!result.Message) {
        this.hotSlotGameList1 = result.Result;
       
        for(let o of this.hotSlotGameList1[0].games){
          this.$set(this.hostObj, o.id, true);
        }
      } else {
        this.$toast(result.Message);
      }
    },
    async loadFixPosPromoEntiy_INRAsync() {
      let result = await loadFixPosPromoEntiy_INR();
      if (!result.Message) {
        this.fixPosPromoEntiy = result.Result;
      } else {
        this.$toast(result.Message);
      }
    },  
    async qeuryAllGameListByGameTypeAsync(gameType) {
      let result = await qeuryAllGameListByGameType(gameType);
      if (!result.Message) {
        this.gameTypeAllGameList = result.Result;
      } else {
        this.$toast(result.Message);
      }
    },
    async queryPromosIeAsync() {
      let result = await queryPromosIe(0);
      if (!result.Message) {
        this.promo.menues = result.Result.promoMenues;
        this.promo.promos = result.Result.promoModels;

        let list = [];
        for (let o of result.Result.promoModels) {
          if (o.bannerStatus == 1) {
            list.push(o);
          }
        }

        this.banners = list.sort(this.sort);
      } else {
        this.$toast(result.Message);
      }
    },
    async gameLoginAsync(id,plat) {
      let tempWindow = window.open("","_blank");
      let result = await gameLoginById(
        id,
        plat
      );
      
      if (!result.Message) {
        if(result.Result.link.indexOf('<!DOCTYPE')==-1){
          tempWindow.location = result.Result.link;
          
        }else{
          tempWindow.document.write(result.Result.link);
          tempWindow.document.close();
        }
      } else {
        if (tempWindow != null) {
          tempWindow.close();
        }

        //this.showGameBox = false;
        this.$toast.fail(result.Message);
      }
    },
    next(o) {
      o.scrollTo({
        left: o.scrollLeft + 150,
        behavior: 'smooth'
      });
    },
    prev(o) {
      o.scrollTo({
        left: o.scrollLeft - 150,
        behavior: 'smooth'
      });
    },
    onSwipeChange(index){
      this.current=index;
    },
    bannerPrev() {
      if (this.$refs.bannerSwipe) {
        this.$refs.bannerSwipe.prev();
      }
    },
    bannerNext() {
      if (this.$refs.bannerSwipe) {
        this.$refs.bannerSwipe.next();
      }
    },
    async initMessageData() {
      if (!this.isLoggedIn) {
        this.messageCount = 0;
        this.siteMessage.list = [];
        return;
      }
      await this.qeuryMessageCountAsync();
      await this.querySiteChatAsync();
    },
    async qeuryMessageCountAsync() {
      let result = await qeuryMessageCount();
      if (!result.Message) {
        this.messageCount = result.Result || 0;
      } else {
        this.messageCount = 0;
      }
    },
    switchNoticeTab(index) {
      this.currentIndexNotice = index;
      if (index === 0 && this.noticeMessage.list.length === 0) {
        this.queryNoticeAsync();
      }
      if (index === 1 && this.isLoggedIn) {
        this.qeuryMessageCountAsync();
        if (this.siteMessage.list.length === 0) {
          this.querySiteChatAsync();
        }
      }
    },
    openNoticeAll() {
      const parent = this.$parent;
      if (!this.isLoggedIn) {
        parent.loginShow = true;
        return;
      }
      parent.noticeShow = true;
      parent.currentIndexNotice = this.currentIndexNotice;
      if (this.currentIndexNotice === 0) {
        parent.queryNoticePageAsync(1);
      } else {
        parent.querySiteChatAsync(1);
      }
    },
    async queryNoticeAsync() {
      let result = await queryNotice();
      if (!result.Message) {
        this.noticeMessage.list = (result.Result.notices || []).slice(0, 3);
      }
    },
    async querySiteChatAsync() {
      let result = await querySiteChat(1);
      if (!result.Message) {
        this.siteMessage.list = (result.Result.modelList || []).slice(0, 3);
      }
    },
    async initAppDownload() {
      const parent = this.$parent;
      if (parent.appData && parent.appData.quanzhan_android) {
        this.appData = parent.appData;
      } else {
        let result = await queryAppData();
        if (!result.Message) {
          this.appData = result.Result;
          if (parent.appData !== undefined) {
            parent.appData = result.Result;
          }
        }
      }
      this.$nextTick(() => {
        this.switchAppQr(this.appPlatform);
      });
    },
    getAppDownloadUrl(platform) {
      const key = platform === 'ios' ? 'quanzhan_ios' : 'quanzhan_android';
      const item = this.appData[key];
      return item && item.apps ? item.apps : '';
    },
    switchAppQr(platform) {
      this.appPlatform = platform;
      const url = this.getAppDownloadUrl(platform);
      if (!url) return;
      this.$nextTick(() => {
        const el = document.getElementById('home_qrcode');
        if (!el) return;
        el.innerHTML = '';
        this.homeQrcode = new QRCode('home_qrcode', {
          text: url,
          width: 84,
          height: 84
        });
      });
    },
  } 
}
</script>

<style scoped>
.home{
display: flex;
max-width: 100%;
box-sizing: border-box;
margin-top: 0.08rem;
}

.home .left{
width: 13.86rem;
max-width: 13.86rem;
min-width: 0;
box-sizing: border-box;
overflow: hidden;
}

.home .right{
width: 4.1rem;
max-width: 4.1rem;
display: flex;
flex-direction: column;
gap: 0.16rem;
box-sizing: border-box;
}

.home .right .msg-tabs{
display: flex;
gap: 0.08rem;
}

.home .right .msg-tabs li{
flex: 1;
height: 0.56rem;
display: flex;
justify-content: center;
align-items: center;
gap: 0.08rem;
background: transparent;
border: 1px solid #282828;
border-radius: 0.08rem;
font-size: 0.2rem;
color: #999;
cursor: pointer;
position: relative;
padding: 0 0.12rem;
box-sizing: border-box;
}

.home .right .msg-tabs li .tab-icon{
width: 0.2rem;
height: 0.2rem;
flex-shrink: 0;
}

.home .right .msg-tabs li.on{
background: #282828;
border-color: #282828;
color: #fff;
font-weight: 600;
}

.home .right .msg-tabs li.tab-site.has-unread{
background: #600068;
border-color: transparent;
color: #fff;
}

.home .right .msg-tabs li.tab-site.has-unread::after{
content: '';
position: absolute;
inset: 0;
border-radius: 0.08rem;
padding: 1px;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
-webkit-mask-composite: xor;
mask-composite: exclude;
pointer-events: none;
}

.home .right .msg-tabs li.tab-site .tab-tag{
position: absolute;
right: 0.12rem;
top: 50%;
transform: translateY(-50%);
padding: 0 0.08rem;
height: 0.19rem;
line-height: 0.19rem;
font-size: 0.1rem;
font-weight: bold;
background: #FFFFFF19;
border-radius: 0.48rem;
white-space: nowrap;
box-sizing: border-box;
}

.home .right .msg-tabs li.tab-site .tab-tag.unread{
background: #FC5415;
border-color: #FC5415;
color: #fff;
font-size: 0.11rem;
font-weight: 600;
min-width: 0.24rem;
text-align: center;
padding: 0 0.06rem;
}

.home .right .msg-list{
display: flex;
flex-direction: column;
gap: 0.16rem;
}

.home .right .msg-item{
flex-shrink: 0;
height: 1.68rem;
background: #282828;
border-radius: 0.16rem;
padding: 0.16rem;
box-sizing: border-box;
display: flex;
flex-direction: column;
justify-content: space-between;
overflow: hidden;
}

.home .right .msg-item .title{
font-size: 0.16rem;
color: #fff;
font-weight: 600;
margin: 0;
line-height: 1.3;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}

.home .right .msg-item .content{
flex: 1;
min-height: 0;
font-size: 0.16rem;
color: #999;
line-height: 1.5;
word-break: break-all;
overflow: hidden;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
padding-top: 0.08rem;
}

.home .right .msg-item.notice .content{
font-size: 0.16rem;
}

.home .right .msg-item .time{
font-size: 0.14rem;
color: #ffffff33;
flex-shrink: 0;
}

.home .right .msg-empty{
height: 1.68rem;
background: #282828;
border-radius: 0.16rem;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
}

.home .right .msg-empty img{
width: 0.56rem;
height: 0.56rem;
}

.home .right .msg-empty span{
font-size: 0.14rem;
color: #999;
margin-top: 0.04rem;
}

.home .right .msg-foot{
height: 0.48rem;
display: flex;
align-items: center;
justify-content: center;
background: #282828;
border-radius: 0.16rem;
font-size: 0.14rem;
color: #999;
cursor: pointer;
gap: 0.04rem;
}

.home .right .msg-foot span:first-child{
color: #fff;
}

.home .right .msg-foot .arrow{
width: 0.16rem;
height: 0.16rem;
background: url("@/img/right.png") no-repeat center center;
background-size: contain;
margin-left: 0.04rem;
}

.home .right .app-dl{
width: 100%;
height: 2.44rem;
border-radius: 0.16rem;
background: url("@/img/appdl.png") no-repeat left center;
background-size: cover;
position: relative;
overflow: hidden;
}

.home .right .app-dl .qr-side{
position: absolute;
right: 0.24rem;
top: 50%;
transform: translateY(-50%);
display: flex;
flex-direction: column;
align-items: center;
gap: 0.08rem;
}

.home .right .app-dl .qr-box{
width: 1.08rem;
height: 1.08rem;
background: #fff;
border-radius: 0.08rem;
padding: 0.06rem;
box-sizing: border-box;
display: flex;
justify-content: center;
align-items: center;
overflow: hidden;
}

.home .right .app-dl .qr-box >>> img,
.home .right .app-dl .qr-box >>> canvas{
width: 100% !important;
height: 100% !important;
}

.home .right .app-dl .qr-side p{
margin: 0;
font-size: 0.16rem;
color: #fff;
font-weight: 600;
white-space: nowrap;
}

.home .right .app-dl .app-btns{
display: flex;
gap: 0.08rem;
margin-top: 0.04rem;
}

.home .right .app-dl .app-btns span{
min-width: 0.48rem;
height: 0.28rem;
padding: 0 0.08rem;
border-radius: 0.08rem;
border: 1px solid rgba(255, 255, 255, 0.2);
background: rgba(255, 255, 255, 0.08);
font-size: 0.12rem;
color: #fff;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
box-sizing: border-box;
white-space: nowrap;
}

.home .right .app-dl .app-btns span.on{
border-color: transparent;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
font-weight: bold;
}
.home .gr ul{
width:100%;
display:flex;
gap: 0.16rem;
align-items:center;
}

.home .gr ul li{
width:1.28rem;
height:0.56rem;
display:flex;
justify-content: center;
align-items: center;
cursor: pointer;
border-radius: 0.08rem;
gap:0.08rem;
background: #282828;
}

.home .gr ul li img{
display: block;
width:0.24rem;
height:0.24rem;
}

.home .gr ul li span{
display: block;
font-size: 0.2rem;
color:#ffffff;
}

.home .gr ul li.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius:0.08rem;
font-weight: bold;
}
.banner{
  width:100%;
  display:flex;
  gap: 0.24rem;
  margin-top: 0.24rem;
}
.banner .m-banner{
  width:8.84rem;
  height:3.87rem;
  border-radius: 0.16rem;
  overflow: hidden;
  position: relative;
}

.banner .m-banner img{
width:8.84rem;
height:3.87rem;
}

.banner .m-banner .next{
width:1.12rem;
height:0.56rem;
display: flex;
align-items: center;
justify-content: space-between;
background: #202020;
border-radius: 0.16rem;
cursor: pointer;
position: absolute;
bottom: 0.24rem;
right: 0.24rem;
padding:0 0.08rem;
}

.banner .m-banner .next span{
display: block;
width:0.4rem;
height:0.4rem;
line-height:0.4rem;
text-align: center;
color:#ffffff;
font-size: 0.24rem;
font-weight: bold;
border-radius: 0.16rem;
}

.banner .m-banner .next span:first-child{
background: url('@/img/back.png') no-repeat center center #ffffff1a;
background-size: cover;
}

.banner .m-banner .next span:last-child{
background: url('@/img/right.png') no-repeat center center #ffffff1a;
background-size: cover;
}


/*@media screen and (max-width: 1366px) {
.home .gr ul{
  gap:0.16rem;
}
    .banner{
      gap:0.16rem;
    }
    .banner .m-banner{
      width:8.5rem;
      height:3.72rem;
    }

    .banner .m-banner img{
      width:100%;
      height:3.72rem;
    }
}*/

.banner .p-banner{
height:3.87rem;
}

.banner .p-banner ul{
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.24rem;
}
.banner .p-banner ul li{
width:4.3rem;
height: 1.815rem;
background-position: 100% 100%;
background-size: cover;
border-radius: 0.16rem;
background-repeat: no-repeat;
display: flex;
align-items: center;
padding-left:0.24rem;
}


.banner .p-banner ul li div{
height: 0.96rem;
display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.banner .p-banner ul li div p{
  font-size: 0.32rem;
  color:#ffffff;
  /* 仅文字周围发光，不要整块阴影 */
  text-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.7);
  font-weight: bold;
}

/*
@media screen and (max-width: 1366px) {
    .banner .p-banner{
      height:3.72rem;
    }

    .banner .p-banner ul{
      gap:0.16rem;
    }

    .banner .p-banner ul li{
      width:3.8035rem;
      height:1.76rem;
    }  
}*/

.games{
margin: 0.24rem 0;
position: relative;
}
.games p{
  display:flex;
  align-items: center;
  font-size: 0.2rem;
  font-weight: bold;
  
}
.games p img{
width:0.32rem;
height:0.32rem;
margin-right: 0.08rem;
}

.games ul{
display: flex;
flex-wrap: wrap;
margin-top:0.24rem;
gap: 0.24rem;
}

.games ul.h,
.games ul.g,
.games ul.m{
justify-content:flex-start;
gap: 0.24rem;
flex-wrap: wrap;
}

/*
 * 1920 设计稿：左侧内容区 13.86 - 0.24*2 = 13.38rem
 * g / g h：203*6 + 24*5 = 1338px → 6×2.03 + 5×0.24 = 13.38rem，刚好排满
 * h / m h：430*3 + 24*2 = 1338px → 3×4.3 + 2×0.24 = 13.38rem
 */
.games ul.g li{
width: 2.03rem;
flex-shrink: 0;
}

.games ul.h:not(.g) li,
.games ul.m li{
width: 4.3rem;
flex-shrink: 0;
}

.games ul li{
cursor: pointer;
transition: all 0.3s ease;
position: relative;
}

.games ul li:hover{
transform: scale(1.05);
}

.games ul.g li img{
width: 2.03rem;
height: 2.03rem;
border-radius: 0.16rem;
display: block;
}

.games ul.h:not(.g) li img{
width: 4.3rem;
height: 2rem;
border-radius: 0.16rem;
display: block;
}

.games ul.m li img{
width: 4.3rem;
height: 2rem;
border-radius: 0.08rem;
display: block;
}

.games ul li span{    
position: absolute;
top:50%;
margin-top:-0.12rem;
left: 0.24rem;
font-size: 0.24rem;
font-weight: bold;
}

.games dl{
display: flex;
gap: 0.08rem;
margin-top: 0.24rem;
}

.games dl dd{
width: 1.08rem;
height: 0.37rem;
line-height: 0.37rem;
text-align: center;
font-size: 0.14rem;
font-weight: 600;
background: #202020;
border-radius: 0.08rem;
cursor: pointer;
}

.games dl dd.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.games .prev{
width: 0.48rem;
height: 0.48rem;
background: url('@/img/back.png') no-repeat center center;
background-size: contain;
cursor: pointer;
position: absolute;
left: 0;
top: 50%;
}

.games .next{
width: 0.48rem;
height: 0.48rem;
background: url('@/img/right.png') no-repeat center center;
background-size: contain;
cursor: pointer;
position: absolute;
right: 0;
top: 50%;
}

/*@media screen and (max-width: 1366px) {
    .games ul{
      gap: 0.16rem;
    }

    .games ul li img{
      width:2.98rem;
      height:1.36rem;
    }
    .games ul.g{
      gap: 0.16rem;
      max-width: 12.38rem;
    }

    .games ul.g li img{
      width:1.6314rem;
      height:1.6314rem;
    }
    
}*/

/* ===== responsive overrides start (safe to delete) ===== */

/*@media screen and (max-width: 1600px) {
  .banner {
    gap: 0.24rem;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 8.5rem;
    height: 3.72rem;
  }

  .banner .p-banner {
    height: 3.72rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
  }

  .banner .p-banner ul li {
    width: 6.1rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.24rem;
  }

  .games ul li img {
    width: 3.5rem;
    height: 1.6rem;
  }

  .games ul.g {
    gap: 0.24rem;
  }

  .games ul.g li img {
    width: 1.63rem;
    height: 1.63rem;
  }
}

@media screen and (max-width: 1366px) {
  .banner {
    gap: 0.16rem;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 8.5rem;
    height: 3.72rem;
  }

  .banner .p-banner {
    height: 3.72rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
  }

  .banner .p-banner ul li {
    width: 3.8035rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 2.98rem;
    height: 1.36rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.6314rem;
    height: 1.6314rem;
  }
}

@media screen and (max-width: 1024px) {
  .home .gr ul li{
    width:0.96rem;
  }

  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 9.12rem;
    height: 4rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 4.48rem;
    height: 1.76rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 4.48rem;
    height: 1.76rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.64rem;
    height: 1.64rem;
  }
}

@media screen and (max-width: 820px) {
.home .gr ul{
  gap: 0.08rem;
}
  .home .gr ul li{
    width:0.88rem;
  }

  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 7.08rem;
    height: 3.4461rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 3.46rem;
    height: 1.46rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 3.46rem;
    height: 1.46rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.64rem;
    height: 1.64rem;
  }
}

@media screen and (max-width: 768px) {


  .banner {
    gap: 0.16rem;
     flex-wrap: wrap;
  }

  .banner .m-banner,
  .banner .m-banner img {
    width: 6.66rem;
    height: 3.3578rem;
  }

  .banner .p-banner {
    height: 1.76rem;
  }

  .banner .p-banner ul {
    gap: 0.16rem;
    flex-direction: row;
  }

  .banner .p-banner ul li {
    width: 3.25rem;
    height: 1.4rem;
  }

  .games ul {
    gap: 0.16rem;
  }

  .games ul li img {
    width: 3.25rem;
    height: 1.4rem;
  }

  .games ul.g {
    gap: 0.16rem;
  }

  .games ul.g li img {
    width: 1.2rem;
    height: 1.2rem;
  }
}*/
/* ===== responsive overrides end (safe to delete) ===== */

</style>

